<!--
    我的课程-我的订单
    功能：展示购买课程订单数据
    说明：旧版本页面
-->
<template>
  <div
    v-loading="loading"
    class="myOrder">
    <el-link
      :underline="false"
      class="app-webview-back"
      @click="$router.go(-1)"
    >
      <i class="el-icon-arrow-left"/>
      返回
    </el-link>

    <el-tabs
      v-model="tabs.active"
      @tab-click="handleClick">
      <el-tab-pane
        v-for="item in tabs.list"
        :key="item.name"
        :label="item.label"
        :name="item.name">
        <AppList
          v-if="tabs.active == item.name"
          :list.sync="item.list"
          :api="item.api"
          title="">
          <AppSearch
            slot="search"
            :order="{ type: 'id', name: 'desc'}"
            :search-call="searchCall"
            :search-arr="searchArr"/>
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in (tabs.active === 'hasCancel' ? columnsCancel : columns)"
                v-if="!column.hide"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :formatter="column.formatter"
              />

              <el-table-column
                label="状态"
                width="120px"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.status === 1"
                    class="pay-status-1">待支付</span>
                  <span
                    v-else-if="scope.row.status === 2"
                    class="pay-status-2">已支付</span>
                  <span
                    v-else-if="scope.row.status === 3"
                    class="pay-status-3">已耗完</span>
                  <span
                    v-else-if="scope.row.status === 4"
                    class="pay-status-3">已取消</span>
                  <span
                    v-else
                    class="pay-status-1">待支付</span>
                </template>
              </el-table-column>

              <el-table-column
                label="操作"
                width="240px"
              >
                <template slot-scope="scope">
                  <div class="link-oper flex">
                    <template v-if="scope.row.status === 1">
                      <el-link @click="classBuy(scope.row)">去支付</el-link>
                      <b>|</b>
                    </template>
                    <template v-else-if="scope.row.status === 2">
                      <el-link @click="goClass(scope.row)">去上课</el-link>
                      <b>|</b>
                    </template>
                    <template v-else-if="scope.row.status === 3">
                      <el-link @click="$router.push(`/myClass/myOrder/timeStatistics?id=${scope.row.commodities_id}`)">耗课记录</el-link>
                      <b>|</b>
                    </template>
                    <!--<template v-else>
                        <el-link @click="classBuy(scope.row)">去支付</el-link>
                        <b>|</b>
                      </template>-->
                    <el-link @click="showDetail(scope.row.id)">查看详情</el-link>
                    <template v-if="scope.row.status === 1">
                      <b>|</b>
                      <el-link @click="confirmCancel(scope.row.id)">取消订单</el-link>
                    </template>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :visible.sync="dialogCheck.show"
      title="支付确认"
      class="dialog-sp1 dialog-success dialog-check"
      width="420px"
      @close="watchClear">
      <div class="check-tip flex ac">{{ dialogCheck.data.prompt }}</div>
      <div class="check-con">
        <p class="flex ac jb">
          <span class="gray">总所需支付：</span>
          <span>{{ dialogCheck.data.coin_need }}金币</span>
        </p>
        <p class="flex ac jb">
          <span class="gray">套餐剩余金币抵扣：</span>
          <span>{{ dialogCheck.data.coin_paid }}金币</span>
        </p>
        <p class="flex ac jb">
          <span class="gray">还需支付金币：</span>
          <span>{{ dialogCheck.data.cash_pay }}金币</span>
        </p>
        <p class="flex ac jb">
          <span class="gray">现金支付：</span>
          <span class="red">{{ dialogCheck.data.cash_pay }}元</span>
        </p>
      </div>
      <div class="check-img">
        <!--        <img :src="dialogCheck.data.recharge.code_img_url">-->
        <el-button
          type="primary"
          @click="getCover">去支付</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogsuccess"
      title="支付确认"
      class="dialog-sp1 dialog-success"
      width="288px"
      @close="reload">
      <div class="dialog-success-icon flex ac jc">
        <i/>
        完成支付
      </div>
      <div class="flex jc">
        <el-button
          type="primary"
          @click="dialogsuccess = false">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogDetail.show"
      title="订单详情"
      class="dialog-sp1"
      width="647px">
      <div class="dialog-detail">
        <div class="detail-row">
          <div class="detail-col flex jb">
            <div><span class="gray">商品名称：</span>{{ dialogDetail.data.commodities.name || '--' }}</div>
            <div><span class="gray">商品编号：</span>{{ dialogDetail.data.commodities.code }}</div>
            <div><span class="gray">订单号：</span>{{ dialogDetail.data.code }}</div>
          </div>
          <div class="detail-col flex jb">
            <div><span class="gray">创建时间：</span>{{ dialogDetail.data.created_at }}</div>
            <div><span class="gray">创建账户：</span>{{ dialogDetail.data.user.mobile }}</div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-col flex jb">
            <div><span class="gray">线下课时单价（/课时/次）：</span>原价：{{ dialogDetail.data.commodities.offline_price }}金币</div>
            <div><span class="gray">优惠价：</span>{{ dialogDetail.data.commodities.offline_discount_price }}金币</div>
          </div>
          <div class="detail-col flex jb">
            <div><span class="gray">线上课时单价（/课时/学生/次）：</span>原价：{{ dialogDetail.data.commodities.online_price }}金币</div>
            <div><span class="gray">优惠价：</span>{{ dialogDetail.data.commodities.online_discount_price }}金币</div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-col flex jb">
            <div><span class="gray">线下课次（/课时/次）：</span>{{ dialogDetail.data.offline_num }}次</div>
          </div>
          <div class="detail-col flex jb">
            <div><span class="gray">线上学生课次（/课时/学生/次）：</span>{{ dialogDetail.data.online_num }}次</div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-col flex jb">
            <div><span class="gray">支付状态：</span>{{ dialogDetail.data.status == 4 ? '已取消' : dialogDetail.data.status_text }}</div>

            <div v-if="dialogDetail.data.status == 4 && dialogDetail.data.cancelled_at"><span class="gray">取消时间：</span>{{ dialogDetail.data.cancelled_at }}</div>
            <div v-else-if="dialogDetail.data.paid_at"><span class="gray">支付时间：</span>{{ dialogDetail.data.paid_at }}</div>
          </div>
          <div class="detail-col flex jb">
            <div/>
            <div><span class="gray">套餐金币抵扣：</span>{{ dialogDetail.data.coin_paid }}金币</div>
          </div>
          <div class="detail-col flex jb">
            <div/>
            <div><span class="gray">原总价：</span>{{ dialogDetail.data.original_coin }}金币</div>
          </div>
          <div class="detail-col flex jb">
            <div/>
            <div><span class="gray">现金支付：</span>{{ dialogDetail.data.cash_paid }}元</div>
          </div>
          <div class="detail-col flex jb">
            <div/>
            <div><span class="gray">优惠总价：</span><span class="red">{{ dialogDetail.data.discount_coin }}金币</span></div>
          </div>
        </div>
      </div>
      <div class="detail-foot flex jc">
        <el-button
          type="primary"
          @click="dialogDetail.show = false">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import index from './';

export default index;
</script>

<style scoped lang="scss">
  @import '../../../assets/reset.scss';
  @import "../../Goods/ClassBuy/index.scss";
  @import "index.scss";

  .dialog-success-icon i {
    background: url(../../Goods/ClassBuy/assets/success.png);
  }
</style>



// WEBPACK FOOTER //
// src/views/MyClass/MyOrder/index.vue